import { render, staticRenderFns } from "./billingPage.vue?vue&type=template&id=6b566278&scoped=true"
import script from "./billingPage.vue?vue&type=script&lang=js"
export * from "./billingPage.vue?vue&type=script&lang=js"
import style0 from "./billingPage.vue?vue&type=style&index=0&id=6b566278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b566278",
  null
  
)

export default component.exports